import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dialog-create-rol',
  templateUrl: './dialog-create-rol.component.html',
  styleUrls: ['./dialog-create-rol.component.css']
})
export class DialogCreateRolComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
